module.exports = __webpack_public_path__ + "img/hr-tree-04-e-trunk.cc2ea6bc.png";